import React, { lazy, useState, useEffect } from "react";
const JsonEditorReact = lazy(() => import("./jsonEditorReact.component"));

const JsonEditorWrapper = (props) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => setLoaded(true), []);

  if (!loaded) return null;

  return <JsonEditorReact {...props} />;
};

export default JsonEditorWrapper;
